import MyExpApi from "apps/myExperience/enum/MyExpApi";
import { useParams } from "react-router-dom";
import { useCopies } from "shared/hooks/useCopies";
import { ApiEventParticipant } from "shared/types/ApiEventParticipant";
import { successToast } from "shared/utils/toastNotification";
import { useGetApiData, usePostApiData } from "shared/datalayer";
import { ApiActivityEventParticipantCalendarInvite } from "shared/types/ApiActivityEventParticipantCalendarInvite";

export function useGetParticipantsListForCalendarInvite() {
  const { programParticipantId } = useParams();
  return useGetApiData<Array<ApiEventParticipant>>(
    MyExpApi.PARTICIPANTS_LIST_FOR_CALENDAR_INVITE,
    {
      params: {
        activityAdminId: programParticipantId
      }
    },
    {
      enabled: Boolean(programParticipantId)
    }
  );
}

export function useSendCalendarInvite() {
  const copies = useCopies();
  return usePostApiData<void, ApiActivityEventParticipantCalendarInvite>(
    MyExpApi.SEND_CALENDAR_INVITE_BY_ACTIVITY_ADMIN,
    {
      onSuccess: response => {
        successToast(copies.get("notification.sent.success"));
      }
    }
  );
}
